import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './providers/UserProvider';
import { ShortcutsProvider } from './providers/ShortcutsProvider';
import { ChannelProvider } from './providers/ChannelProvider';
import { App } from './App';

const root = createRoot(document.getElementById('app')!);
root.render(
  <BrowserRouter>
    <UserProvider>
      <ChannelProvider>
        <ShortcutsProvider>
          <App />
        </ShortcutsProvider>
      </ChannelProvider>
    </UserProvider>
  </BrowserRouter>
);
